export * from "./types/type";

import MonitorSdk from "./libs/monitor-sdk";
import { isIPAddress } from "./utils/tool";
import BrowserBase from "./plugins/browser-base";
import BrowserError from "./plugins/browser-error";
import BrowserPerformance from "./plugins/browser-performance";
import BrowserRequest from "./plugins/browser-request";

const defaultConfig = {
  endpoint: 'https://app.hopegoo.com/monitorApi/useBehaviorLog/postData',
  app: '',
  version: '',
  enable: true,
}

let sdk: MonitorSdk;
function init(_config = {}) {
  if (typeof window === 'undefined') return;

  const config = Object.assign({}, defaultConfig, _config);

  if (!config.app) {
    throw new Error('app name is required');
  }
  if (!config.version) {
    throw new Error('app version is required');
  }

  if ((_config as any).enable === undefined) {
    if (isIPAddress(window.location.hostname) || window.location.hostname === 'localhost') {
      config.enable = false;
    }
  }

  sdk = new MonitorSdk(config);
  sdk.use(new BrowserBase());
  sdk.use(new BrowserError());
  sdk.use(new BrowserPerformance());
  sdk.use(new BrowserRequest({ exclude: ['/seaManatee/'] }));
}

function use(plugin: any) {
  if (sdk) {
    sdk.use(plugin);
  }
}

export { init, use };

if (typeof SonarConfig == 'object') {
  init(SonarConfig);
}

